import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { saveState } from '../store/browserStorage';

export default function recentCasesReducer(state = initialState.recentCases, action) {
  switch (action.type) {
    case types.ADD_CASE: {
      const recentCasesClone = [...state];
      let recentCaseData = [];

      const updateIndex = recentCasesClone.findIndex((caseObject) => {
        return caseObject.caseNumber === action.caseNumber;
      });
      if (updateIndex === -1) {
        recentCaseData = state.concat({
          caseNumber: action.caseNumber,
          dateUpdated: action.dateUpdated,
        });
      } else {
        recentCasesClone[updateIndex].dateUpdated = Date.now();
        recentCaseData = recentCasesClone.sort((v1, v2) => {
          return v1.dateUpdated - v2.dateUpdated;
        });
      }
      localStorage.setItem('recentCases', JSON.stringify(recentCaseData));
      localStorage.setItem('clearAll', false);
      saveState({
        recentCases: recentCaseData,
      });
      return [...recentCaseData];
    }

    case types.REMOVE_CASE: {
      const changedRecentCases = state.filter((caseObject) => {
        return caseObject.caseNumber !== action.caseNumber;
      });
      localStorage.setItem('recentCases', JSON.stringify(changedRecentCases));
      localStorage.setItem('lockedCases', JSON.stringify(changedRecentCases));
      return [...changedRecentCases];
    }

    case types.REMOVE_ALL_OPEN_CASES:
      if (Array.isArray(state)) {
        const changedAllRecentCases = state.filter((caseObject) => {
          return action.caseNumbers.includes(caseObject.caseNumber);
        });
        localStorage.setItem('recentCases', JSON.stringify(changedAllRecentCases));
        localStorage.setItem('lockedCases', JSON.stringify(changedAllRecentCases));
        return [...changedAllRecentCases];
      }
      break;

    default:
      return state;
  }
}
